import { CarlinesWithSalesgroups } from 'src/types';

export const getSalesgroupsFromCarlines = (carlines: CarlinesWithSalesgroups[]) => {
  return carlines
    .map((carline) => carline.salesGroups)
    .filter((c) => c !== null)
    .flat();
};
